export function resetAllState(store: any) {
  const modules = store._modulesNamespaceMap;

  for (const moduleName in modules) {
    const namespace = moduleName;
    const resetAction = `${namespace}resetState`;

    if (store._actions[resetAction]) {
      store.dispatch(resetAction);
    }
  }
}